import { RootStore } from '../../../init-store';
import { ConferenceStatus } from '../../pages/call/constants';
import { cancelCallAction } from '../../pages/call/features/conference/slice';
import { setUserPreferredGridViewAction } from '../../pages/call/features/goloom-video-grid';
import { recordConferenceAction } from '../../pages/call/features/record';
import { toggleShowMyVideoSettings } from '../features/settings';

type ParticipantsCountChangeCallback = (count: number) => void;

let onJoinHandler: VoidFunction | undefined;
let conferenceStatusChangeHandler: ((status: string) => void) | undefined;
let onParticipantsCountChange: ParticipantsCountChangeCallback | undefined;
let isConferenceJoined = false;
let onStreamStartCallback: OnStreamStartCallback | undefined;

export const initHostApi = (store: RootStore) => {
    let lastConferenceStatus: ConferenceStatus | undefined;
    let lastParticipantsCount: number | undefined;

    window.HOST_API = {
        onJoin: (callback: VoidFunction) => {
            onJoinHandler = callback;
            if (isConferenceJoined) {
                onJoinHandler();
            }
        },
        onParticipantsCountChange: (callback, immediate = false) => {
            onParticipantsCountChange = callback;

            if (immediate) {
                lastParticipantsCount = store.getState().call.conference.participants.length;

                callback(lastParticipantsCount);
            }
        },
        startStream: (wsUrl, resolution) => {
            store.dispatch(
                recordConferenceAction({
                    recorder: 'ws',
                    options: { ws: wsUrl, resolution },
                })
            );
        },
        onStreamStart: (callback) => {
            onStreamStartCallback = callback;
        },
        stopStream: () => {
            store.dispatch(cancelCallAction());
        },
        setGridView: (gridView) => {
            store.dispatch(setUserPreferredGridViewAction({ gridView }));
        },
        hideMyVideo: () => {
            store.dispatch(toggleShowMyVideoSettings(false));
        },
        onConferenceStatusChange: (handler: VoidFunction) => {
            conferenceStatusChangeHandler = handler;
        },
    };

    store.subscribe(() => {
        const { conferenceStatus, participants } = store.getState().call.conference;

        if (lastParticipantsCount !== participants.length) {
            lastParticipantsCount = participants.length;
            if (onParticipantsCountChange) {
                onParticipantsCountChange(lastParticipantsCount);
            }
        }

        if (conferenceStatus !== lastConferenceStatus) {
            lastConferenceStatus = conferenceStatus;
            isConferenceJoined = conferenceStatus === ConferenceStatus.JOINED;

            if (typeof conferenceStatusChangeHandler === 'function') {
                conferenceStatusChangeHandler(conferenceStatus);
            }
            if (isConferenceJoined) {
                onJoinHandler?.();
            }
        }
    });
};

export { onStreamStartCallback };
